import axios from 'axios';
import attachAuthToken from '../axiosConfig';
import {
  DetalheDaNota,
  DetalheDoPedido,
  LinhaDoTempoResposta,
  ListaDePecas,
  ListaDePedidos,
  ListarPecasParams,
  ListarPedidosParams,
  RegistrarChegadaInput,
  ResumoDosPedidos,
} from '../../interfaces/PrevisaoPecas';

/*
 * Previsão de Peças (previsao-pecas/at-02): as rotas vivem no backend do SOAC. Até a at-01 a tela
 * falava com o backend próprio do módulo (porta 8084) e só existia com a env
 * `REACT_APP_PREVISAO_PECAS_URL` — o gate saiu (decisão do Victor, 23/10/2026).
 *
 * Nenhuma função engole erro: "nenhum pedido a acompanhar" e "não consegui perguntar" levam a
 * conclusões opostas, e quem distingue é a tela.
 */
const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
});

attachAuthToken(api);

export async function listarPedidos(params: ListarPedidosParams = {}): Promise<ListaDePedidos> {
  const { data } = await api.get<ListaDePedidos>('/previsao-pecas/pedidos', { params });
  return data;
}

export async function resumoDosPedidos(params: ListarPedidosParams = {}): Promise<ResumoDosPedidos> {
  const { data } = await api.get<ResumoDosPedidos>('/previsao-pecas/pedidos/resumo', { params });
  return data;
}

export async function buscarPedido(pedidoId: string): Promise<DetalheDoPedido> {
  const { data } = await api.get<DetalheDoPedido>(`/previsao-pecas/pedidos/${pedidoId}`);
  return data;
}

export async function buscarNota(notaId: string): Promise<DetalheDaNota> {
  const { data } = await api.get<DetalheDaNota>(`/previsao-pecas/notas/${notaId}`);
  return data;
}

export async function listarPecas(params: ListarPecasParams = {}): Promise<ListaDePecas> {
  const { data } = await api.get<ListaDePecas>('/previsao-pecas/itens', { params });
  return data;
}

export async function buscarLinhaDoTempo(pedidoItemId: string): Promise<LinhaDoTempoResposta> {
  const { data } = await api.get<LinhaDoTempoResposta>(`/previsao-pecas/itens/${pedidoItemId}/linha-do-tempo`);
  return data;
}

export async function registrarChegada(
  pedidoId: string,
  pedidoItemId: string,
  dto: RegistrarChegadaInput,
): Promise<{ id: string; excedente: boolean }> {
  const { data } = await api.post(`/previsao-pecas/pedidos/${pedidoId}/itens/${pedidoItemId}/chegadas`, dto);
  return data;
}

export async function cancelarChegada(chegadaId: string, motivo: string): Promise<void> {
  await api.delete(`/previsao-pecas/chegadas/${chegadaId}`, { data: { motivo } });
}

/** O status do espelho de compras do SOAC — a mesma forma que a aba Sincronização do Dashboard lê. */
export async function obterStatusDaSincronizacao(): Promise<Record<string, unknown>> {
  const { data } = await api.get<Record<string, unknown>>('/previsao-pecas/sincronizacao');
  return data;
}
